import { useState, useEffect, useContext } from "react";
import { FaAward, FaCalculator, FaCalendar, FaChartArea, FaCogs, FaFileSignature, FaLandmark, FaMoneyBill, FaUpload } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import { useCarriereEvents } from "contexts/CarriereEventsContext";
import DateDepartRetraite from "components/app/AuditComplet/Retraite/Parametrage/DateDepart/DateDepartRetraite";
import MajorationEnfantRetraite from "components/app/AuditComplet/Retraite/Parametrage/Majorations/MajorationEnfantRetraite";
import TauxRemplacement from "components/app/AuditComplet/Retraite/Parametrage/TauxRemplacement/TauxRemplacement";
import PrelevementsSociaux from "components/app/AuditComplet/Retraite/Parametrage/PrelevementsSociaux/PrelevementSociaux";
import AjoutContratRetrPersoPageModal from "./ajout contrat retraite perso modal";
import PointRetraite from "components/app/AuditComplet/Retraite/Parametrage/Points/PointRetraite";
import LectureRG from "components/app/AuditComplet/Retraite/Parametrage/ReleveRG/LectureRG";
import { RGContext } from "components/app/AuditComplet/Retraite/Parametrage/ReleveRG/RGProvider";
import InvaliditeRetraite from "components/app/AuditComplet/Retraite/Parametrage/Invalidite/InvaliditeRetraite";
import AutresPensionsModal from "./autres pensions modal";

const ParamRetraitePageModal = (props) => {
  const context = useContext(AppContext);
  const RGCtx = useContext(RGContext);
  const { trackEvent } = useCarriereEvents();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // Réinitialiser à la première page uniquement quand la modale s'ouvre
    if (props.visible) {
      setCurrentPage(1);
      trackEvent('PARAM', 'TAB_DATE_DEPART');
    }
  }, [props.visible]);
  return (
    <>
      <Pager
        validateDisabled={
          context.state["DepartDateChoisi" + props.ClientConjoint] === true &&
          (context.state["MoisDepartDateChoisiInput" + props.ClientConjoint].length !== 2 || context.state["AnneeDepartDateChoisiInput" + props.ClientConjoint].length !== 4)
            ? true
            : false
        }
        id="paramRetraitePager"
        withMenu
        pages={[
          {
            isTitle: true,
            title: "Paramètres",
            subTitle: "Paramètres de la retraite",
          },
          {
            label: "Date de départ",
            icon: <FaCalendar />,
            content: <DateDepartRetraite Outil="" ClientConjoint={props.ClientConjoint} />,
          },
          {
            label: "Points",
            icon: <FaCalculator />,
            content: <PointRetraite Outil="" ClientConjoint={props.ClientConjoint} />,
          },

          {
            label: "Majorations",
            icon: <FaAward />,
            content: <MajorationEnfantRetraite Outil="" ClientConjoint={props.ClientConjoint} />,
          },
          {
            label: "Forcer le taux plein",
            icon: <FaCogs />,
            content: <InvaliditeRetraite Outil="" ClientConjoint={props.ClientConjoint} />,
          },
          {
            label: "Import RG",
            icon: <FaUpload />,
            content: <LectureRG Outil="" ClientConjoint={props.ClientConjoint} />,
          },
          {
            label: "Taux de remplacement",
            icon: <FaChartArea />,
            content: <TauxRemplacement Outil="" ClientConjoint={props.ClientConjoint} />,
          },
          {
            label: "Prélèvements sociaux",
            icon: <FaLandmark />,
            content: <PrelevementsSociaux Outil="" ClientConjoint={props.ClientConjoint} />,
          },
          {
            label: "Contrats",
            icon: <FaFileSignature id="contratFacPerso" />,
            content: <AjoutContratRetrPersoPageModal Outil="" ClientConjoint={props.ClientConjoint} AccessRemExpress={false} />,
          },
          {
            label: "Autres pensions",
            icon: <FaMoneyBill/>,
            content: <AutresPensionsModal Outil="" ClientConjoint={props.ClientConjoint} AccessRemExpress={false} />,
          },
        ]}
        page={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
          
          // Map page index to event
          const pageEvents = {
            1: 'TAB_DATE_DEPART',
            2: 'TAB_POINTS',
            3: 'TAB_MAJORATIONS',
            4: 'TAB_TAUX_PLEIN',
            5: 'TAB_IMPORT_RG',
            6: 'TAB_TAUX_REMPLACEMENT',
            7: 'TAB_PRELEVEMENTS',
            8: 'TAB_CONTRATS',
            9: 'TAB_AUTRES_PENSIONS',
          };
          
          if (pageEvents[page]) {
            trackEvent('PARAM', pageEvents[page]);
          }
        }}
        navButtons={{
          // cancel: {},

          previous: {},
          next: {},
          validate: {
            onClick: (evt) => {
              // if (RGCtx.Carriere.length > 0) {
              //   context.handleAddReleveRG(RGCtx.Carriere, props.ClientConjoint);
              // } else if(context.state.TypeSimulation === "Audit complet") {
                context.GetDateDepartRetraite(props.ClientConjoint, context.state);
              // }
              props.onClose();
            },
          },
        }}
      />
    </>
  );
};

export default ParamRetraitePageModal;
